const SET_AFFIRMATION_AND_CATEGORIES = "SET_AFFIRMATION_AND_CATEGORIES";
const SET_REELS_AND_REELS_CATEGORIES = "SET_REELS_AND_REELS_CATEGORIES";

const actionTypes = {
    SET_AFFIRMATION_AND_CATEGORIES,
    SET_REELS_AND_REELS_CATEGORIES,
}
export { actionTypes }